import React from 'react'

const Main = () => {
  return (
    <div className='big-main'>
        <p className='main'>MovieMania</p>
    </div>
  )
}

export default Main